import React, { Fragment, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import numeral from 'numeral';
import { PER_PAGE_SELECT_OPTIONS } from '../../../../config';
import { getCurrencySymbol } from '../../../../helpers';

import SpinnerBlock from '../../../common/SpinnerBlock';
import TableRow from './TableRow';
import Pagination from '../../../common/Pagination';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const SeparationRow = styled('tr')`
  height: 48px;
  background: #fafafa;

  .light {
    color: #98a6ad;
  }

  strong {
    font-weight: 700;
  }

  .large {
    font-size: 16px;
    line-height: 19px;
  }
`;

const Wrapper = styled('div')`
  font-size: 14px;
  margin-top: 24px;
  .fixed-table-body {
    border-bottom: 1px solid #dee2e6;
  }
  .table {
    width: 100%;
    margin-bottom: 0;
    min-width: 800px;
    .right {
      text-align: right;
    }
  }
  .table tr {
    padding-top: 7px;
    padding-bottom: 7px;
    color: #323a46;
  }
  .table .thead-light th {
    padding-top: 9px;
    padding-bottom: 9px;
    height: 60px;
    font-size: 14px;
    span {
      font-weight: 500;
    }
  }
  strong {
    display: block;
    font-weight: 500;
  }
  .text-muted {
    color: #98a6ad;
  }
  .red {
    color: #f1556c;
  }
`;

const BillTable = (props) => {
  const {
    items,
    THEAD_ITEMS,
    totalItems,
    page,
    handlePageSelect,
    perPageCount,
    setPerPageCount,
    urlSearchStr,
  } = props;

  const { t } = useAutoTranslation();

  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(false);

  const months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ];

  useEffect(() => {
    setLoading(true);
    let newItems = [];

    items.forEach((item) => {
      const mainYear = moment(item.date).year();
      const month = months[moment(item.date).month()];
      if (newItems.length) {
        const equalYear = newItems.find((y) => y.year == mainYear);
        if (equalYear) {
          newItems.forEach((year) => {
            if (year.year == mainYear) {
              const equalMonth = year.months.find((m) => m.month == month);
              if (equalMonth) {
                year.months.forEach((m) => {
                  if (m.month == month) {
                    m.items.push(item);
                  }
                });
              } else {
                year.months.push({
                  month: month,
                  items: [item],
                });
              }
            }
          });
        } else {
          newItems.push({
            year: mainYear,
            months: [{ month: month, items: [item] }],
          });
        }
      } else {
        newItems.push({
          year: mainYear,
          months: [{ month: month, items: [item] }],
        });
      }
    });
    setBills(newItems);
    setLoading(false);
  }, []);

  const handlePerPageSelect = (count) => {
    setPerPageCount(count);
    handlePageSelect(0);
  };

  const getFormatSum = (sum) => {
    return `${numeral(+sum).format('0,0.00')} ${getCurrencySymbol('RUB')}`;
  };

  return (
    <>
      <Wrapper>
        <div className="fixed-table-container">
          <div className="fixed-table-body">
            <table className="table table-centered">
              <thead className="thead-light">
                <tr>
                  <Fragment>
                    {THEAD_ITEMS.map((item) => (
                      <th className={item.class ? item.class : null}>
                        <div>{t(item.title)}</div>
                      </th>
                    ))}
                  </Fragment>
                </tr>
              </thead>
              {!loading ? (
                <tbody>
                  {bills.length ? (
                    bills.map((year) =>
                      year.months.map((month) => (
                        <>
                          <SeparationRow>
                            <td>
                              <div className="d-flex align-items-end">
                                <strong className="large mr-2">{t(month.month)}</strong>
                                <span className="text-muted" style={{ lineHeight: '17px' }}>
                                  {year.year}
                                </span>
                              </div>
                            </td>
                            <td></td>
                            <td></td>
                            <td align="right">
                              <strong>
                                {getFormatSum(
                                  month.items.reduce((sum, current) => sum + current.totalSum, 0),
                                )}
                              </strong>
                            </td>
                            <td></td>
                          </SeparationRow>
                          {month.items.map((item) => (
                            <TableRow key={item.id} item={item} urlSearchStr={urlSearchStr} t={t} />
                          ))}
                        </>
                      )),
                    )
                  ) : (
                    <tr>
                      <td colSpan="5">{t('Ничего не найдено')}</td>
                    </tr>
                  )}
                </tbody>
              ) : null}
            </table>
            {loading ? (
              <div style={{ width: '100%', position: 'relative', height: '150px ' }}>
                <SpinnerBlock show={loading} />
              </div>
            ) : null}
          </div>
        </div>
        <Pagination
          withPerPageCountSelect
          total={totalItems}
          currentPage={Number(page)}
          perPage={perPageCount}
          onPageSelect={(pageIndex) => handlePageSelect(pageIndex)}
          onPerPageSelect={(count) => handlePerPageSelect(count)}
          perPageSelectOptions={PER_PAGE_SELECT_OPTIONS}
        />
      </Wrapper>
    </>
  );
};

export default BillTable;
